import IssueStatus from '@opsbase/lib-issue/IssueStatus';
import Pages from '@opsbase/lib-pages';
import i18n from '@opsbase/lib-i18n';
import CloseIssueIcon from '@opsbase/web-icons/icons/CloseIssueIcon';
import EditIcon from '@opsbase/web-icons/icons/EditIcon';
import ReassignIcon from '@opsbase/web-icons/icons/ReassignIcon';
import ReopenIcon from '@opsbase/web-icons/icons/ReopenIcon';
import React from 'react';
import ItemMenu from './ItemMenu';
export const IssueMenu = React.memo((props) => {
    const { item, ...otherProps } = props;
    if (!item)
        return null;
    const isClosed = item.status === IssueStatus.CLOSED;
    return (React.createElement(ItemMenu, { id: item.id, options: [
            {
                icon: EditIcon,
                label: i18n.t('view'),
                page: Pages.ISSUES_VIEW,
                variant: 'good',
            },
            {
                icon: ReassignIcon,
                label: i18n.t('reassign'),
                page: Pages.ISSUES_REASSIGN,
                variant: 'action',
                visible: !isClosed,
            },
            {
                icon: CloseIssueIcon,
                label: i18n.t('close'),
                page: Pages.ISSUES_CLOSE,
                visible: !isClosed,
                variant: 'warn',
            },
            {
                icon: ReopenIcon,
                label: i18n.t('reopen'),
                page: Pages.ISSUES_REOPEN,
                variant: 'action',
                visible: isClosed,
            },
        ], ...otherProps }));
});
export default IssueMenu;
